<div fxFlex fxLayout="row" fxLayoutGap="1.5rem" style="height:100%; width: 100%; padding: 0 1rem;"
  fxLayoutAlign="end center">
  <a *ngFor="let link of links" [name]="link.name" [appRequireACL]="link.acl" [routerLink]="link.link"
    class="centerText navLink" [ngClass]="{'active':active(link)}" [appRequireOrg]="link.org">
    {{link.display}}</a>
</div>
